import actionTypes from './actionTypes';

const requestReportData = () => ({
    type: actionTypes.REQUEST_REPORT_DATA
});

const reportDataResponse = (success, reportData, errors) => ({
    type: actionTypes.REPORT_DATA_RESPONSE,
    payload: {
        success,
        reportData,
        errors
    }
});

const requestCountry = () => ({
    type: actionTypes.REQUEST_COUNTRY
});

const countryResponse = (success, countries, errors) => ({
    type: actionTypes.COUNTRY_RESPONSE,
    payload: {
        success,
        countries,
        errors
    }
});

const requestFranchise = () => ({
    type: actionTypes.REQUEST_FRANCHISE,
});

const franchiseResponse = (success, franchises, errors) => ({
    type: actionTypes.FRANCHISE_RESPONSE,
    payload: {
        success,
        franchises,
        errors,
    },
});

export default {
    requestReportData,
    reportDataResponse,
    requestCountry,
    countryResponse,
    requestFranchise,
    franchiseResponse,
};